export type ISecureDataZone = {
    sdz: string;
    realm: string;
    fingerprintKdk: string;
    database: DataBaseType | undefined;
};
type DataBaseType = {
    name: string;
    realm: string;
};

export const getSelectedDataZone = (): ISecureDataZone => {
    let env;
    const currentEnvString = localStorage.getItem('env');
    return currentEnvString ? JSON.parse(currentEnvString) : env;
};
